import * as services from 'services/centroAyuda.service';

export const getCentroAyudaData = async () => {
  // Estructura de petición sin redux
  try {
    const helpCtrData = await services.fetchCentroAyuda();
    return { success: true, helpCtrData };
  } catch (error) {
    console.log('Error:', error);
    return { success: false, error };
  }
};
